import { TableRow } from "@mui/material";
import React from "react";
import aderantTheme from "../../../Theme/AderantTheme";
import GridCell from "../GridCell";
import GroupHeaderCell from "../GroupHeaderCell";
import RowPrefix from "../RowPrefix";
import { dataGridStyles } from "./DataGridStyles";
/**
 * A function that renders a row and its cells in the DataGrid.
 */
export default function DataGridRow(props) {
    const { allowSelection, columns, focusedRowId, fixedColumnCount, getColumnWidth, getRowProps, isRowLoading, isRowReadOnly, row, rowIndex } = props;
    const renderCells = [];
    const fixedCells = [];
    let checkboxLabel = "";
    const rowRef = React.useRef(null);
    if (row.isGrouped) {
        checkboxLabel = `${row.id}-group`;
    }
    else {
        row.cells.forEach((cell, index) => {
            if (index == 0) {
                checkboxLabel = cell.value && typeof cell.value === "string" ? cell.value : index.toString();
            }
            const cellElement = (React.createElement(GridCell, { cell: cell, columnWidth: getColumnWidth(cell.column.id), isRowLoading: isRowLoading, style: cell.column.cellStyle, key: `row-${rowIndex}-cell-${index}` }, cell.render("Cell")));
            if (index < fixedColumnCount) {
                fixedCells.push(cellElement);
            }
            else {
                renderCells.push(cellElement);
            }
        });
    }
    return (React.createElement(TableRow, { component: "div", "data-testid": "data-grid-row", tabIndex: 0, ref: rowRef, ...row.getRowProps(getRowProps(row)), key: `${rowIndex}-row`, role: `row${row.isGrouped ? "header" : ""}`, sx: {
            ...(isRowReadOnly && !row.isGrouped ? { "*": { pointerEvents: "none" } } : {}),
            ...props.sx
        } },
        React.createElement("div", { key: `${rowIndex}-row-fixed-cell`, style: {
                ...dataGridStyles.fixedCellsContainer,
                boxShadow: row.isGrouped || fixedColumnCount == 0 ? undefined : `-1px 0px 0px 0 ${aderantTheme.palette.border.main} inset`,
                backgroundColor: "inherit"
            } },
            React.createElement(RowPrefix, { allowSelection: allowSelection, row: row, checkboxLabel: checkboxLabel, isRowLoading: isRowLoading, isRowReadOnly: isRowReadOnly }),
            row.isGrouped ? React.createElement(GroupHeaderCell, { row: row, columns: columns, rowRef: rowRef, focusedRowId: focusedRowId }) : fixedCells),
        renderCells));
}
